import * as Sentry from "@sentry/browser";

const SentryConfigElement = document.querySelector('meta[name="sentry"]')

const dsn = atob(SentryConfigElement.getAttribute('dsn'))

Sentry.init({dsn: dsn})
